export default __webpack_public_path__ + "static/media/ABBvoice_W_Rg.195ea191.woff";